import React from 'react';
import { AccessiwayScript } from "./scripts/AccessiwayScript";
export function EndingBodyScripts() {
  return (
    <div className="ending-body-script">
      <AccessiwayScript />
    </div>
  );
}
